import { CanActivateFn } from "@angular/router";
import { inject } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Router } from "@angular/router";
import { AuthServiceImpl } from "../services/auth.servcice";
import { accessDefaultRoutesMap } from "@app/shared/general/config/access-route-map.config";
import { IAccessTokenPayload } from "../interfaces/access-token.interface";

/**
 * Guard that prevents logged-in users from accessing authentication pages
 * (login, register, forget-password, etc.)
 * If user is logged in with valid token, redirects to dashboard
 */
export const guestGuard: CanActivateFn = async (_route, _state) => {
  const jwtHelper = inject(JwtHelperService);
  const authService = inject(AuthServiceImpl);
  const router = inject(Router);

  const token = authService.getToken();
  const user = authService.getUser();

  // If no token or user, allow access to auth pages
  if (!token || !user) {
    return true;
  }

  // If token is expired, allow access to auth pages
  if (jwtHelper.isTokenExpired(token)) {
    await authService.logout();
    return true;
  }

  const parsedToken = jwtHelper.decodeToken(token as string) as IAccessTokenPayload;

  // User is logged in with valid token, redirect to dashboard
  await router.navigate([accessDefaultRoutesMap[parsedToken.accessType]]);
  return false;
};
